import { gql } from "@apollo/client";

export const CREATE_WITHDRAWAL = gql`
  mutation createWithdrawal(
    $goalId: String!
    $amountInCents: Int!
    $subaccountId: String
    $cancelExistingWithdrawal: Boolean
  ) {
    createWithdrawal(
      input: {
        goalId: $goalId
        amountInCents: $amountInCents
        subaccountId: $subaccountId
        cancelExistingWithdrawal: $cancelExistingWithdrawal
      }
    ) {
      id
      label
      type
      status
      description
      amountInCents
      date
      reason
    }
  }
`;
